import React from "react";

import { useTranslation } from "react-i18next";
import { BsInfoCircle } from "react-icons/bs";

import { ShipmentType } from "../../../../../util/enums";
import { useShipmentContext } from "../../../hooks/useShipmentContext";
import useStyles from "./styles";

const ShipmentTooltip = () => {
  const { shipment } = useShipmentContext();
  const { t: translate } = useTranslation();
  const classes = useStyles();

  const renderPortsTooltips = () => {
    if (shipment?.shipmentType === ShipmentType.AIR || shipment?.shipmentType === ShipmentType.SEA)
      return (
        <>
          {!shipment?.portOfLoadingId && (
            <div className={classes.tooltipTitle}>
              <BsInfoCircle />
              <span>{translate("youMustSelectAShipmentLoadingPortFirst")}</span>
            </div>
          )}
          {!shipment?.portOfDischargeId && (
            <div className={classes.tooltipTitle}>
              <BsInfoCircle />
              <span>{translate("youMustSelectAShipmentDischargePortFirst")}</span>
            </div>
          )}
        </>
      );
  };
  const renderLocationsTooltips = () => {
    if (
      shipment?.shipmentType === ShipmentType.ROAD ||
      shipment?.shipmentType === ShipmentType.RAIL
    )
      return (
        <>
          {!shipment?.origin && (
            <div className={classes.tooltipTitle}>
              <BsInfoCircle />
              <span>{translate("youMustSelectAShipmentOriginFirst")}</span>
            </div>
          )}
          {!shipment?.destination && (
            <div className={classes.tooltipTitle}>
              <BsInfoCircle />
              <span>{translate("youMustSelectAShipmentDestinationFirst")}</span>
            </div>
          )}
        </>
      );
  };

  return (
    <div className={classes.tooltipContainer}>
      {!shipment?.shipmentType && (
        <div className={classes.tooltipTitle}>
          <BsInfoCircle />
          <span>{translate("youMustSelectAShipmentModeFirst")}</span>
        </div>
      )}
      {!shipment?.incoterm && (
        <div className={classes.tooltipTitle}>
          <BsInfoCircle />
          <span>{translate("youMustSelectAShipmentIncotermFirst")}</span>
        </div>
      )}
      {renderPortsTooltips()}
      {renderLocationsTooltips()}
    </div>
  );
};

export default ShipmentTooltip;
